import React, { useEffect, useState } from 'react';
import HomePage from '../screens/oddbods/home';

const Home = () => {
  return (
    <HomePage />
  )
};

export default Home;